// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const rif: CountryValidator<"VE"> = createValidator(
  "ve.rif",
  173,
);

export default rif;
export const compact = rif.compact;
export const format = rif.format;
export const validate = rif.validate;
export const generate = (): string =>
  rif.generate?.() ??
  (() => {
    throw new Error(
      "Validator ve.rif cannot generate values",
    );
  })();
